import React from 'react';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import SocialLinks from './SocialLinks';

function Footer() {
  return (
    <footer className="bg-[#1d1d1f] text-[#f5f5f7] pt-16 pb-8">
      <div className="max-w-[980px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="flex flex-col items-start">
            <img 
              src="https://i.ibb.co/HLq8ksZB/Group-164.png"
              alt="997 Cargo"
              className="h-[54px] mb-6 -ml-2.5"
            />
            <p className="text-sm text-[#86868b] leading-relaxed">
              Ваш надежный партнер в организации поставок из Китая. Комплексные решения для бизнеса и частных лиц.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Услуги</h3>
            <ul className="space-y-3">
              <li>
                <a href="/prices" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  Цены
                </a>
              </li>
              <li>
                <a href="/services/business/search" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  Поиск поставщиков
                </a>
              </li>
              <li>
                <a href="/services/business/logistics" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  Логистика
                </a>
              </li>
              <li>
                <a href="/services/business/forwarding" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  Экспедирование
                </a>
              </li>
              <li>
                <a href="/services/business/payment" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  Оплата поставщикам
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Компания</h3>
            <ul className="space-y-3">
              <li>
                <a href="/about" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  О нас
                </a>
              </li>
              <li>
                <a href="/contacts" className="text-sm text-[#86868b] hover:text-white transition-colors">
                  Контакты
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Контакты</h3>
            <ul className="space-y-3">
              <li>
                <SocialLinks variant="footer" className="justify-start" />
              </li>
              <li>
                <a href="mailto:cargo997@mail.ru" className="text-sm text-[#86868b] hover:text-white transition-colors flex items-center">
                  <Mail className="w-4 h-4 mr-2" />
                  cargo997@mail.ru
                </a>
              </li>
              <li>
                <a href="tel:+8617310189679" className="text-sm text-[#86868b] hover:text-white transition-colors flex items-center">
                  <Phone className="w-4 h-4 mr-2" />
                  +86 (173) 1018-96-79
                </a>
              </li>
              <li>
                <div className="text-sm text-[#86868b] flex items-start">
                  <MapPin className="w-4 h-4 mr-2 mt-1 flex-shrink-0" />
                  <span>广州市白云区同德围同嘉路221号 迪深仓储物流有限公司111号库</span>
                </div>
              </li>
              <li>
                <a
                  href="https://t.me/rdpcargorussia"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-[#86868b] hover:text-white transition-colors flex items-center"
                >
                  Telegram
                  <ExternalLink className="w-4 h-4 ml-1" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-[#424245]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#86868b]">
              © {new Date().getFullYear()} 997 Cargo. Все права защищены
            </p>
            <div className="flex items-center gap-6">
              <a href="/privacy" className="text-sm text-[#86868b] hover:text-white transition-colors">
                Политика конфиденциальности
              </a>
              <a href="/terms" className="text-sm text-[#86868b] hover:text-white transition-colors">
                Условия использования
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;